/**
 * Composition des fournisseurs de contexte. L’ordre n’est pas décoratif :
 *
 *   QueryClientProvider   le cache — `AuthProvider` en dépend pour lire /auth/moi
 *     └ ToastProvider     les notifications — utilisables partout, y compris
 *                         par les écrans de connexion
 *         └ FournisseurApparence  les couleurs et la police du théâtre (PER-07)
 *             └ AuthProvider  la session — les gardes de routes en dépendent
 *                 └ RouterProvider
 *
 * ★ `FournisseurApparence` est **au-dessus** d’`AuthProvider`, et c’est le
 * point : il lit `GET /apparence/publique`, une route sans session, pour que
 * les pages de connexion et la boutique portent déjà les couleurs du théâtre —
 * une personnalisation qui n’apparaîtrait qu’une fois connecté ne
 * personnaliserait rien de ce qu’un visiteur voit (SPEC-BOUTIQUE §6, PER-07).
 * Il ne retarde jamais le rendu : tant que la réponse n’est pas là, les
 * couleurs compilées dans `index.css` s’appliquent.
 */

import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'

import { AuthProvider } from './auth'
import { FournisseurApparence } from './features/apparence'
import { LangueDuTheatre } from './lib/LangueDuTheatre'
import { queryClient } from './lib/query'
import { router } from './router'
import { ToastProvider } from './ui/Toast'

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <FournisseurApparence>
          <AuthProvider>
            {/* ★★ I18N-01 — apprend la langue du théâtre au code non-React
                (`lib/format.ts`, qui écrit les dates). Monté ici, au-dessus du
                routeur, pour qu'il n'existe QU'UN endroit où la langue est
                décidée. Il ne coûte aucune requête : `GET /theatre/publique`
                part déjà depuis `RedirectionRacine` — c'est son 404 qui
                distingue la vitrine de l'adresse d'un théâtre — et TanStack
                déduplique sur la même clé. */}
            <LangueDuTheatre />
            <RouterProvider router={router} />
          </AuthProvider>
        </FournisseurApparence>
      </ToastProvider>
    </QueryClientProvider>
  )
}
